/**
 * Common configuration for external HMAC-authenticated services
 */

import { appConfig } from "../../config/keycloak.js";

/**
 * HMAC Authentication Configuration
 */
export const EXTERNAL_CONFIG = {
  // Common client credentials
  clientId: "external",
  clientSecret: "SGbsy1qTWxzPXuH7GSmCj7CcVzmkUXI4h8fMU0whf68=",
  dropContextPath: false,
  
  // Service-specific context paths
  services: {
    merchant: "/merchant-service",
    application: "/application-service",
    communication: "/communication-service",
    template: "/template-service",
    parameters: "/param-service"
  }
} as const;

/**
 * Get base URL for external services
 * Usa configuración centralizada de keycloak.js
 */
export function getExternalBaseUrl(): string {
  return appConfig.apiUrl;
}

